<template>
    <div id="locationField">
        <input class="search-location"
               id="autocomplete"
               ref="autocompleteRef"
               placeholder="Enter your address"
               type="text"/>
    </div>

</template>

<script>
    import {mapMutations} from "vuex";

    export default {
        name: "AutocompleteSearchbox",
        props: ["google", "map"],
        data() {
            return {
                autocomplete: null,
                place: [],
            }
        },
        mounted() {
            this.initAutocomplete()
        },
        methods: {
            ...mapMutations([
                    "setUserLocation"
                ]
            ),
            initAutocomplete() {
                this.autocomplete = new this.google.maps.places.Autocomplete(
                    this.$refs["autocompleteRef"]);

                // Dont pay for unnecessary data
                this.autocomplete.setFields(['geometry']);
                this.autocomplete.addListener('place_changed', this.setNewCenter);

            },
            setNewCenter() {
                this.place = this.autocomplete.getPlace();
                if (!this.place.geometry) {
                    this.$notify({
                        group: 'google-maps-api-notifications',
                        type: 'info',
                        title: 'The place ' + this.place.name + ' does not exist',
                        closeOnClick: 'true'
                    });
                    return;
                }

                this.setUserLocation(this.place.geometry.location);
                this.map.panTo(this.place.geometry.location);
                this.map.setZoom(15);
            }
        }
    }
</script>

<style scoped lang="scss">

    .locationField {
        width: 5vw;
    }

    .search-location {
        opacity: 1;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
        border: 0;
        border-radius: 8px;
        margin: 6px 4px;

        color: inherit;
        font-size: 15px;

        padding: 3px 16px 3px 16px;
        height: 48px;
        width: 100%;
        overflow: hidden;
        z-index: 2;
        vertical-align: top;
        transition-property: color;
        transition-duration: 0.3s;

        &
        :focus {
            outline: 0;
        }

    }

    @media screen and (min-width: 640px) {
        .search-location {
            padding: 6px 32px;
        }
    }

</style>